import React, { Component, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getYearsWithData, getMonths, getEmployeeRevShareByMonth } from "../../apis/revshare/ReportsApi";
import DataGridNew from "../common/DataGrids/DataGrid-new";
import { Accordion, Button, Card, Col, Container, Form, Row, Tab, Tabs, Spinner } from "react-bootstrap";
import FormRow from "../common/forms/FormRow";
import SelectInput from "../common/forms/SelectInput";

class EmployeeByMonthReport extends Component {
  render() {
    return (
      <Container fluid>
        <Row>
          <Form>
            <FormRow
              columns={[
                <SelectInput
                  default={this.state.year.toString()}
                  label="Year"
                  onChange={this.changeYear}
                  options={this.state.years}
                  ref={(element) => (this.yearSelect = element)}
                />,
              ]}
            />
          </Form>
        </Row>
        <Row>
          <Col>
            <EmployeeByMonthGrid isManager={this.props.isManger} year={this.state.year} />
          </Col>
        </Row>
      </Container>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      year: new Date().getFullYear(),
      years: [],
    };

    this.changeYear = this.changeYear.bind(this);
  }

  componentDidMount() {
    getYearsWithData()
      .then((years) => this.setState({ years: years }))
      .catch((error) => {
        throw error;
      });
  }

  changeYear() {
    this.setState({ year: this.yearSelect.value });
  }
}

EmployeeByMonthReport.propTypes = {
  isManger: PropTypes.bool,
};

export default EmployeeByMonthReport;

const EmployeeByMonthGrid = ({ isManager, year }) => {
    const headers = [
        {
            key: "consultant",
            label: "Consultant",
            columns: [
                { label: "ID", key: "consultantId", isNumber: false },
                { label: "Consultant", key: "consultant", isNumber: false },
                { label: "Subacct", key: "subaccount", isNumber: false }
            ]
        },
        {
            key: "dollars",
            label: "Dollars",
            columns: [
                { label: "Start Bal.", key: "startValue", isNumber: true },
                { label: "Earned", key: "valueEarned", isNumber: true },
                { label: "Used", key: "valueUsed", isNumber: true },
                { label: "End Bal.", key: "currentBalance", isNumber: true },
                { label: "Net Diff.", key: "netValueDifference", isNumber: true },
            ]
        },
        {
            key: "hours",
            label: "Hours",
            columns: [
                { label: "Start Bal.", key: "startHours", isNumber: true },
                { label: "Earned", key: "hoursEarned", isNumber: true },
                { label: "Used", key: "hoursUsed", isNumber: true },
                { label: "End Bal", key: "currentHours", isNumber: true },
                { label: "Net Diff.", key: "netHoursDifference", isNumber: true },
            ]
        },
  ];

  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [months, setMonths] = useState([]);
  const [consultantFirstSelect, setConsultantFirstSelect] = useState(null);
  const [consultantLastSelect, setConsultantLastSelect] = useState(null);

  useEffect(() => {
    getMonths(year)
      .then((months) => setMonths(months))
      .catch((error) => {
        throw error;
      });
    getEmployeeRevShareByMonth(year, isManager)
      .then((data) => {
        setData(data);
        setLoading(false);
        setAllData(data);
      })
      .catch((error) => {
        throw error;
      });
  }, [year,isManager]);

  const filterGrid = () => {
    let filtered = allData;
    if (consultantFirstSelect.value !== "All") {
      filtered = filtered.filter((i) => i.consultant.split(" ")[0] === consultantFirstSelect.value);
    }
    if (consultantLastSelect.value !== "All") {
      filtered = filtered.filter((i) => i.consultant.split(" ")[1] === consultantLastSelect.value);
    }
    setData(filtered);
  };

  return (
    <>
      <Row>
        <Col xs="12">
          <Accordion>
            <Card style={{ border: "none" }}>
              <Accordion.Toggle as={Button} variant="link" eventKey="0">
                Filter
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <Form>
                  <FormRow
                    columns={[
                      <SelectInput
                        default="All"
                        label="Consultant First"
                        onChange={filterGrid}
                        options={data
                          .map((i) => i.consultant.split(" ")[0])
                          .filter((v, i, a) => a.indexOf(v) === i)
                          .sort()}
                        ref={(element) => setConsultantFirstSelect(element)}
                      />,
                      <SelectInput
                        default="All"
                        label="Consultant Last"
                        onChange={filterGrid}
                        options={data
                          .map((i) => i.consultant.split(" ")[1])
                          .filter((v, i, a) => a.indexOf(v) === i)
                          .sort()}
                        ref={(element) => setConsultantLastSelect(element)}
                      />,
                    ]}
                  />
                </Form>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Col>
      </Row>
      <Row>
        {loading ? <Spinner animation="border" /> : null}
        <Tabs justify variant="tabs">
          {months.map((month) => (
            <Tab eventKey={month.name} key={month.name} title={month.name}>
              <DataGridNew
                data={data.filter((i) => i.month.number === month.number)}
                exportName="EmployeeByMonthReport"
                headers={headers}
              />
            </Tab>
          ))}
        </Tabs>
      </Row>
    </>
  );
};

EmployeeByMonthGrid.propTypes = {
  isManager: PropTypes.bool,
  year: PropTypes.number.isRequired,
};
